import Companies from '@/api/companies'
import Jobs from '@/api/jobs'

export default {
  namespaced: true,
  state: {
    company: null,
    jobs: [],
    detail: null,
    stats: null,
    companies: [],
    companiesLoading: false,
    companyCategories: []
  },
  getters: {
    company: state => state.company,
    jobs: state => state.jobs,
    detailInfo: state => state.detail,
    stats: state => state.stats
  },
  mutations: {
    setCompany (state, company) {
      state.company = company
    },
    setJobs (state, jobs) {
      state.jobs = jobs
    },
    setDetail (state, detail) {
      state.detail = detail
    },
    setStats (state, stats) {
      state.stats = stats
    },
    resetJobs (state) {
      state.jobs = []
    },
    setCompanies (state, companies) {
      state.companies = companies
    },
    setCompaniesLoading (state, companiesLoading) {
      state.companiesLoading = companiesLoading
    },
    setCompanyCategories (state, companyCategories) {
      state.companyCategories = companyCategories
    }
  },
  actions: {
    async getCompany ({ commit }) {
      const company = await Companies.current()
      commit('setCompany', company[0])
    },
    async getJobs ({ commit }, companyId) {
      const jobs = await Jobs.companyJobs(companyId)
      commit('setJobs', jobs)
    },
    async getPublishedJobs ({ commit }, companyId) {
      const jobs = await Jobs.companyPublishedjobs(companyId)
      commit('setJobs', jobs)
    },
    async getDetail ({ commit }, companyId) {
      const detail = await Companies.getDetail(companyId)
      commit('setDetail', detail[0])
    },
    async getStats ({ commit }, companyId) {
      const stats = await Companies.getStats(companyId)
      commit('setStats', stats[0])
    },
    async getCompanyCategories ({commit}) {
      try {
        const companyCategories = await Companies.getCompanyCategories()
        commit('setCompanyCategories', companyCategories)
      } catch (e) {
        console.log('error', e)
      }
    },
    async getCompanies ({commit}, filters) {
      try {
        commit('setCompaniesLoading', true)
        const companies = await Companies.getCompanies(filters)
        commit('setCompanies', companies)
        commit('setCompaniesLoading', false)
      } catch (e) {
        commit('setCompaniesLoading', false)
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/companies.js